import React  from 'react';
import '../myutils';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { push as pushAction } from 'react-router-redux';
import { translate } from 'react-admin';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

const styles = {
  card: {
    // maxWidth: 345,
  },
  media: {
    // height: 140,
  },
};

function CardLink(props) {
  const { classes, title, titleData, body, icon, className, push, link, translate, subtitle, subtitleData, component, variant } = props;
  return (
    <Link to={link} style={{textDecoration: 'none'}}>
    <Card className={className} onClick={()=>push({link})}>
      {icon}
      <CardMedia
        className={classes.media}
      />
      <CardContent>
      <Typography gutterBottom variant={(variant!==undefined)?variant:"headline"} component={(component!==undefined)?component:"h2"}>
          {translate(title)}
          {(titleData!==undefined)&&titleData}
        </Typography>
        <Typography gutterBottom variant={(variant!==undefined)?variant:"headline"} component={(component!==undefined)?component:"h2"}>
          {translate(subtitle)}
          {(subtitleData!==undefined)&&subtitleData}
        </Typography>
        <Typography component="p">
            {body}
        </Typography>
      </CardContent>
      <CardActions>
      </CardActions>
    </Card>
    </Link>
  );
}

CardLink.propTypes = {
  classes: PropTypes.object.isRequired,
    push: PropTypes.func,
};

export default connect(null, {
    push: pushAction,
})(translate(withStyles(styles)(CardLink)));
